module.exports = __webpack_public_path__ + "557956a252ddfa4f4c0b0330b8848668.pdf";